import React from 'react';
import '../css/event-modal.css';

function EventDetailModal({ onClose, event }) {
  if (!event) return null;

  const getEventTypeLabel = (type) => {
    const types = {
      concert: '🎤 Concierto',
      festival: '🎵 Festival',
      workshop: '🎓 Taller',
      other: '📌 Otro',
    };
    return types[type] || type;
  };

  const labelStyle = {
    color: '#FFD700',
    fontSize: '11px',
    fontWeight: '800',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textShadow: '0 0 8px rgba(255,215,0,0.6)'
  };

  const valueStyle = {
    color: '#FFFFFF',
    fontSize: '14px',
    margin: 0,
    fontWeight: '600',
    textShadow: '0 0 10px rgba(255,215,0,0.4)'
  };

  const cardStyle = {
    padding: '12px 14px',
    borderRadius: '10px',
    background: 'rgba(0,0,0,0.6)',
    border: '1px solid rgba(255,215,0,0.35)',
    boxShadow: '0 0 15px rgba(255,215,0,0.15), inset 0 0 10px rgba(255,215,0,0.08)',
    backdropFilter: 'blur(6px)'
  };

  const divider = {
    height: '1px',
    background: 'linear-gradient(90deg, transparent, #FFD700, transparent)',
    margin: '10px 0'
  };

  return (
    <div
      className="event-modal-overlay"
      onClick={onClose}
      style={{ background: 'rgba(0,0,0,0.9)' }}
    >
      <div
        className="event-modal-container"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#050505',
          border: '2px solid #FFD700',
          boxShadow: '0 0 40px rgba(255,215,0,0.25)',
          borderRadius: '14px',
          maxWidth: '1050px'
        }}
      >

        <button className="modal-close" onClick={onClose} style={{
          color: '#FFD700',
          fontSize: '18px'
        }}>✕</button>

        {/* HEADER */}
        <div style={{ padding: '18px 22px' }}>
          <h2 style={{
            color: '#FFD700',
            fontSize: '22px',
            fontWeight: '900',
            letterSpacing: '1px',
            textShadow: '0 0 15px rgba(255,215,0,0.6)'
          }}>
            📋 {event.title}
          </h2>
        </div>

        {/* BODY */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1.1fr 1fr',
            gap: '18px',
            padding: '20px'
          }}
        >

          {/* LEFT */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

            {event.image && (
              <div style={{
                borderRadius: '12px',
                overflow: 'hidden',
                border: '2px solid #FFD700',
                boxShadow: '0 0 25px rgba(255,215,0,0.25)'
              }}>
                <img
                  src={event.image}
                  alt={event.title}
                  style={{
                    width: '100%',
                    height: '260px',
                    objectFit: 'cover',
                    filter: 'contrast(1.05) saturate(1.1)'
                  }}
                />
              </div>
            )}

            <div style={cardStyle}>
              <label style={labelStyle}>Descripción</label>
              <p style={{ color: '#FDFDFD', fontSize: '13px', marginTop: 6 }}>
                {event.description}
              </p>
            </div>

            <div style={cardStyle}>
              <label style={labelStyle}>Ubicación</label>
              <p style={valueStyle}>{event.location}</p>
            </div>

          </div>

          {/* RIGHT */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

            <div style={cardStyle}>
              <label style={labelStyle}>Tipo</label>
              <p style={valueStyle}>
                {getEventTypeLabel(event.eventType)}
              </p>
            </div>

            <div style={divider} />

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>

              <div style={cardStyle}>
                <label style={labelStyle}>Fecha</label>
                <p style={valueStyle}>
                  {new Date(event.date).toLocaleDateString('es-ES')}
                </p>
              </div>

              <div style={cardStyle}>
                <label style={labelStyle}>Hora</label>
                <p style={valueStyle}>{event.time}</p>
              </div>

            </div>

            <div style={divider} />

            <div style={cardStyle}>
              <label style={labelStyle}>Capacidad</label>
              <p style={valueStyle}>
                {event.capacity ? `${event.capacity} personas` : '∞'}
              </p>
            </div>

            {event.ticketPrice && (
              <div style={{
                ...cardStyle,
                border: '2px solid #FFD700',
                boxShadow: '0 0 25px rgba(255,215,0,0.35)'
              }}>
                <label style={labelStyle}>Precio</label>
                <p style={{
                  color: '#FFD700',
                  fontSize: '16px',
                  fontWeight: '900',
                  textShadow: '0 0 12px rgba(255,215,0,0.7)'
                }}>
                  ${event.ticketPrice}
                </p>
              </div>
            )}

          </div>
        </div>

        {/* FOOTER BUTTON */}
        {event.ticketUrl && (
          <div style={{
            padding: '0 20px 20px',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <a
              href={event.ticketUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: '100%',
                maxWidth: '420px',
                textAlign: 'center',
                padding: '14px',
                borderRadius: '10px',
                background: 'linear-gradient(90deg, #FFD700, #ffb300)',
                color: '#000',
                fontWeight: '900',
                letterSpacing: '1px',
                boxShadow: '0 0 25px rgba(255,215,0,0.4)'
              }}
            >
              🎫 COMPRAR ENTRADAS
            </a>
          </div>
        )}

      </div>
    </div>
  );
}

export default EventDetailModal;